/*ICONO TIKTOK FOOTER*/
document.addEventListener("DOMContentLoaded", function() {
  const tiktokItems = document.querySelectorAll('li a[href*="tiktok.com"]');
  
  tiktokItems.forEach((tiktokItem) => {
    // Evita duplicar si ya tiene el icono
    if (!tiktokItem.querySelector(".ion-social-tiktok")) {
      const icon = document.createElement("i");
      icon.className = "ion-social-tiktok";
      tiktokItem.prepend(icon);
    }
  });
});

/*POP UP PRODUCTO INTERNO, AGREGAR AL CARRITO*/
document.addEventListener("DOMContentLoaded", function () {
  // Función que traduce el popup
  function traducirPopupCarrito() {
    // Mensaje de éxito
    const successMsg = document.querySelector(".success-message");
    if (successMsg) {
      successMsg.innerHTML = '<i class="fa fa-check-circle"></i> Producto agregado exitosamente al carrito de compras';
    }

    // Texto de "Hay X artículos en tu carrito"
    const totalItem = document.querySelector(".total_item");
    if (totalItem) {
      const countEl = totalItem.querySelector(".cart_count");
      const count = countEl ? countEl.textContent : "";
      totalItem.innerHTML = `Hay <span class="cart_count bigcounter">${count}</span> artículos en tu carrito.`;
    }

    // Texto de "Precio total"
    const totalLabel = document.querySelector(".total_price_label");
    if (totalLabel) {
      totalLabel.textContent = "Precio total:";
    }

    // Botones
    const btns = document.querySelectorAll(".lezada-button");
    btns.forEach((btn) => {
      const href = btn.getAttribute("href");
      if (href) {
        if (href.includes("/collections")) btn.textContent = "Continuar comprando";
        else if (href.includes("/cart")) btn.textContent = "Ver carrito";
        else if (href.includes("/checkout")) btn.textContent = "Finalizar compra";
      }
    });

    // Checkbox de términos
    const labelCond = document.querySelector("label[for='popup_ageree_term_cond']");
    if (labelCond) {
      labelCond.textContent = "Acepto los términos y condiciones";
    }
  }

  // Ejecutar cuando se abre el popup
  const observer = new MutationObserver(() => {
    const popup = document.querySelector("#modalAddToCart.show, .ajax-popup.show");
    if (popup) traducirPopupCarrito();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Traducción inicial por si el popup ya está cargado
  traducirPopupCarrito();
});

// Esperar a que cargue el DOM
document.addEventListener("DOMContentLoaded", function () {

  // Traducciones del botón "Agregar al carrito" y sus estados
  const traducirBotonCarrito = () => {
    const boton = document.querySelector('.cart-title');
    const loading = document.querySelector('.cart-loading');
    const added = document.querySelector('.cart-added');
    const unavailable = document.querySelector('.cart-unavailable');

    if (boton) boton.innerText = "Agregar al carrito";   // texto principal
    if (loading) loading.innerText = "Espera...";         // Wait..
    if (added) added.innerText = "Agregado";              // Added
    if (unavailable) unavailable.innerText = "No disponible"; // Unavailable
  };

  traducirBotonCarrito();

  // Si el tema usa AJAX y cambia el botón dinámicamente, volvemos a aplicar la traducción
  document.addEventListener("click", function () {
    setTimeout(traducirBotonCarrito, 200);
  });
});

/*CARRITO COMPRA - POSICION ELEMENTOS*/
document.addEventListener("DOMContentLoaded", function () {
    // Detectar si es mobile
    if (window.innerWidth <= 768) {
        document.querySelectorAll("tr").forEach(row => {
            const name = row.querySelector(".product-name");
            const price = row.querySelector(".product-price");
            const qty = row.querySelector(".product-quantity");
            const total = row.querySelector(".total-price");

            if (name && price && qty && total) {

                // Crear el nuevo contenedor vertical
                const mobileBox = document.createElement("div");
                mobileBox.classList.add("mobile-product-box");

                // Pasar los elementos al nuevo div
                mobileBox.appendChild(name);
                mobileBox.appendChild(price);
                mobileBox.appendChild(qty);
                mobileBox.appendChild(total);

                // Insertar el nuevo div después de la imagen
                const imgCell = row.querySelector(".product-thumbnail");
                imgCell.insertAdjacentElement("afterend", mobileBox);
            }
        });
    }
});

/*TRADUCCION*/
document.addEventListener("DOMContentLoaded", function () {
  const textos = document.querySelectorAll(".soldout-title, .cart-text");

  textos.forEach(el => {
    if (el && el.textContent.trim().toLowerCase() === "soldout") {
      el.textContent = "Agotado";
    }
  });
});


